import { Dictionary } from "../../../../../types";
import { StoreFeature } from "../../../core/store/types";

export interface SecurityData extends Dictionary<string, any>
{
    errorType: "OK" | "NoSecurity" | "InternalError";
    securityMessage: string;
    userMessage: string;
} 

export const securityData: StoreFeature<SecurityData> = {};